import { render, staticRenderFns } from "./SearchLayeredNavigation.vue?vue&type=template&id=96619c8a&"
import script from "./SearchLayeredNavigation.vue?vue&type=script&lang=js&"
export * from "./SearchLayeredNavigation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {LayeredFilters: require('/~/src/modules/opus-ecom/components/LayeredFilters.vue').default,OpusTitle: require('/~/src/modules/opus/components/Title.vue').default,CategoryTree: require('/~/src/components/CategoryTree.vue').default,OpusButton: require('/~/src/modules/opus/components/Form/Button.vue').default,LayeredSort: require('/~/src/modules/opus-ecom/components/LayeredSort.vue').default,ProductList: require('/~/src/modules/opus-ecom/components/ProductList.vue').default,OpusCard: require('/~/src/modules/opus/components/Card.vue').default,LayeredPagination: require('/~/src/modules/opus-ecom/components/LayeredPagination.vue').default})
